import { FormattedMessage } from "react-intl";
import { AddressForm, type AddressFormProps } from "../AddressForm";
import { SameAddressToggle } from "./SameAddressToggle";
import { SectionCard } from "./SectionCard";

/** The AddressForm bindings a section forwards from the form hook. */
export type AddressBindings = Pick<
  AddressFormProps,
  "values" | "onChange" | "onBlur" | "error"
>;

export interface BillingSectionProps extends AddressBindings {
  useSameAddress: boolean;
  onToggleSameAddress: (checked: boolean) => void;
  /** Hidden when no hardware ships (e.g. the discount deal) — no shipping at all. */
  showSameAddressToggle: boolean;
}

/**
 * Billing Information card: the address form (with Country + State) followed by
 * the same-address toggle. Takes only the bindings it forwards, so it can be
 * rendered standalone in tests with fakes.
 */
export function BillingSection({
  values,
  onChange,
  onBlur,
  error,
  useSameAddress,
  onToggleSameAddress,
  showSameAddressToggle,
}: BillingSectionProps) {
  return (
    <SectionCard
      testId="billing-card"
      title={
        <FormattedMessage
          id="pixi_wizard.payment_shipping.billing.title"
          defaultMessage="Billing Information"
        />
      }
    >
      <AddressForm
        values={values}
        includeState
        testIdPrefix="billing"
        onChange={onChange}
        onBlur={onBlur}
        error={error}
      />
      {showSameAddressToggle && (
        <SameAddressToggle
          checked={useSameAddress}
          onChange={onToggleSameAddress}
        />
      )}
    </SectionCard>
  );
}
